import { useEffect } from 'react';
import { applySeo, breadcrumbJsonLd } from '../lib/seo';

const PAGES = {
  '/ueber-uns': {
    title: 'Über uns | Domain-Preisvergleich.de',
    description: 'Warum es Domain-Preisvergleich.de gibt: Wir vergleichen Domain-Preise aller Anbieter transparent, ohne Sternchen und ohne Kleingedrucktes.',
  },
  '/ratgeber': {
    title: 'Domain-Kauf-Ratgeber | Domain-Preisvergleich.de',
    description: 'Transfer-Gebühren, Kleingedrucktes, WHOIS, Registrar-Lock: Der komplette Ratgeber für den sicheren Domain-Kauf – mit faire-Anbieter-Checkliste.',
  },
  '/domain-technik': {
    title: 'Domain-Technik: Wie funktioniert DNS? | Domain-Preisvergleich.de',
    description: 'Das Domain Name System (DNS) einfach erklärt: Wie Domains funktionieren, wer das Internet verwaltet und warum Ihre Domain Ihre Adresse im Netz ist.',
  },
  '/fuer-provider': {
    title: 'Für Provider | Domain-Preisvergleich.de',
    description: 'Sie sind Domain-Provider? Werden Sie bei uns gelistet, präsentieren Sie Ihr Logo und Ihre Angebote und liefern Sie Preise per API – als Pro-Partner.',
  },
  '/kontakt': {
    title: 'Kontakt | Domain-Preisvergleich.de',
    description: 'Fehler melden, Preise korrigieren oder Feedback geben: Kontaktieren Sie Domain-Preisvergleich.de.',
  },
  '/impressum': {
    title: 'Impressum & Datenschutz | Domain-Preisvergleich.de',
    description: 'Impressum und Datenschutzerklärung von Domain-Preisvergleich.de.',
  },
  '/anbieter': {
    title: 'Anbieter im Vergleich | Domain-Preisvergleich.de',
    description: 'Alle Domain-Registrare und Hosting-Anbieter im Preisvergleich – aktuell, transparent und ohne versteckte Kosten.',
  },
};

export default function useSeoForPage(path) {
  useEffect(() => {
    const page = PAGES[path];
    if (!page) return;
    applySeo({
      title: page.title,
      description: page.description,
      path,
      jsonLd: breadcrumbJsonLd([
        { name: 'Startseite', path: '/' },
        { name: page.title.split(' | ')[0], path },
      ]),
    });
  }, [path]);
}
